module.exports = "/img/34.f73b54.webp";